<template>
  <div id="survey-info">
    <b-form @submit.prevent="onSubmitForm((isNext = true))">
      <div class="position-relative w-100">
        <b-row class="title-name-wrp mb-2">
          <b-col cols="6">
            <div class="title-survey mb-2">
              <div class="font-medium-5 text-black mt-2">Title Name</div>
              <div>
                <b-form-input
                  v-model="formData.titleName"
                  class="input-title-name"
                />
              </div>
            </div>
          </b-col>
          <b-col
            cols="6"
            class="d-flex justify-content-end align-items-center ml-minus-45px"
          >
            <div class="d-flex">
              <div>
                <global-button
                  text-class="secondary-text"
                  custom-class="secondary-border default-btn ml-1"
                  :btn-label="'Back'"
                  @click.native="onBack"
                />
                <global-button
                  text-class="primary-text"
                  custom-class="primary-border default-btn ml-1"
                  :btn-label="'Save'"
                  :disabled="validFormDisable"
                  @click.native="onSubmitForm((isNext = false))"
                />
                <global-button
                  :type="'submit'"
                  custom-class="next-btn text-white ml-1"
                  :btn-label="stepActive == 3 ? 'Publish' : 'Next'"
                  :disabled="
                    stepActive == 3 ? validFormDisablePublish : validFormDisable
                  "
                />
              </div>
            </div>
          </b-col>
        </b-row>
        <div class="survey-tab">
          <b-row>
            <b-col cols="12">
              <div class="position-relative">
                <b-tabs v-model="stepActive" class="custom-tab">
                  <b-tab
                    active
                    :title="'Question'"
                    :title-link-class="[
                      'font-medium-5',
                      { 'text-muted': stepActive !== 0 },
                      { bypass: modeEditor },
                    ]"
                    lazy
                  >
                    <question-tab
                      :isEdit="isEditForm"
                      :surveyGroupId="surveyGroupId"
                      :formQuestionData="formQuestion"
                      :surveyAction="surveyAction"
                      @onSetFormQuestion="onSetFormQuestion"
                      @onSetFormData="onSetFormData"
                      @onSetTitleName="onSetTitleName"
                      @EditQuestion="EditQuestion"
                    />
                  </b-tab>
                  <b-tab
                    :title="'Permission'"
                    :title-link-class="[
                      'font-medium-5',
                      { 'text-muted': stepActive !== 1 },
                      { bypass: modeEditor },
                    ]"
                    lazy
                  >
                    <permission-tab
                      :isEdit="isEditForm"
                      :formData="formData"
                      @onSetPermissionData="onSetPermissionData"
                    />
                  </b-tab>
                  <b-tab
                    :title="'Privilege'"
                    :title-link-class="[
                      'font-medium-5',
                      { 'text-muted': stepActive !== 2 },
                      { bypass: modeEditor },
                    ]"
                    lazy
                  >
                    <privilege-tab
                      :isEdit="isEditForm"
                      @onSetPrivilegeData="onSetPrivilegeData"
                    />
                  </b-tab>
                  <b-tab
                    :title="'Score'"
                    :title-link-class="[
                      'font-medium-5',
                      { 'text-muted': stepActive !== 3 },
                      { bypass: modeEditor },
                    ]"
                    lazy
                  >
                    <score-tab
                      :isEdit="isEditForm"
                      @onSetScoreData="onSetScoreData"
                      @onSetMaxScore="onSetMaxScore"
                      @EditSetResult="onSubmitForm((isNext = false))"
                    />
                  </b-tab>
                </b-tabs>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import QuestionTab from "./Components/QuestionTab.vue";
import PermissionTab from "./Components/PermissionTab.vue";
import PrivilegeTab from "./Components/PrivilegeTab.vue";
import ScoreTab from "./Components/ScoreTab.vue";

import useSurveyInfo from "./hooks/useSurveyInfo";
export default {
  components: { QuestionTab, PermissionTab, PrivilegeTab, ScoreTab },
  setup() {
    const {
      modeEditor,
      stepActive,
      quizId,
      onNextStep,
      onPreviousStep,

      formData,
      formQuestion,
      onSetPermissionData,
      onSetPrivilegeData,
      onSetScoreData,
      onSetFormQuestion,
      onSetFormData,
      onSubmitForm,
      isNext,
      onSetTitleName,
      EditQuestion,
      onBack,
      isEditForm,
      surveyGroupId,
      validFormDisable,
      validFormDisablePublish,
      onSetMaxScore,
      surveyAction,
    } = useSurveyInfo();

    return {
      modeEditor,
      stepActive,
      quizId,
      onNextStep,
      onPreviousStep,

      formData,
      formQuestion,
      onSetPermissionData,
      onSetPrivilegeData,
      onSetScoreData,
      onSetFormQuestion,
      onSetFormData,
      onSubmitForm,
      isNext,
      onSetTitleName,
      EditQuestion,
      onBack,
      isEditForm,
      surveyGroupId,
      validFormDisable,
      validFormDisablePublish,
      onSetMaxScore,
      EditQuestion,
      surveyAction,
    };
  },
};
</script>

<style >
@import "~@/assets/css/override-styles/progress-nav.css";

#survey-info .title-name-wrp {
  width: 106%;
  margin-left: -27px;
  margin-top: -26px;
  background-color: #ffffff;
  padding: 0 20px;
}

#survey-info .input-title-name {
  background-color: transparent;
}

#survey-info .next-btn {
  border-color: #007fff !important;
  background-color: #007fff !important;
}

#survey-info .primary-border {
  border-color: #67ad5b !important;
}

#survey-info .primary-text {
  color: #67ad5b !important;
}

#survey-info .secondary-btn {
  background-color: #707070 !important;
}

#survey-info .secondary-border {
  border-color: #707070 !important;
}

#survey-info .secondary-text {
  color: #707070 !important;
}

#survey-info .secondary-border:hover {
  background-color: #707070 !important;
  border-color: #707070 !important;
}

#survey-info .secondary-border:hover .secondary-text {
  color: #ffffff !important;
}

#survey-info .default-btn {
  background-color: #ffffff !important;
}

#survey-info .custom-button {
  padding: 12px 45px;
}

#survey-info .ml-minus-45px {
  margin-left: -45px;
}
</style>